
//client side error object to track errors and warnings

function MessageStack(){
    this.NOTICE = 0;
    this.SUCCESS = 1;
    this.WARNING = 2;
    this.ERROR = 3;
    this.DURATION = 4000;
    this.messageStack = [];

    this.AddMessage = function(msg,type,duration){
        var message = {
            message: msg,
            type: type || this.NOTICE,
            duration: duration || this.DURATION
        }
        this.messageStack.push(message);
    };

    this.AddNotice = function(msg,duration){
        //var duration = duration || this.DURATION
        this.AddMessage(msg,this.NOTICE,duration);
    };

    this.AddSuccess = function(msg,duration){
        var message = {
            message: msg,
            type: this.SUCCESS,
            duration: duration || this.DURATION
        }
        this.messageStack.push(message);
    };

    this.AddError = function(msg,duration){
        var message = {
            message: msg,
            type: this.ERROR,
            duration: duration || this.DURATION
        }
        this.messageStack.push(message);
    };

    this.AddWarning = function(msg,duration){
        var message = {
            message: msg,
            type: this.WARNING,
            duration: duration || this.DURATION
        }
        this.messageStack.push(message);
    };

    this.GetMessages = function(){
        return this.messageStack;
    };

    this.HasError = function(){
        var count = 0;
        for(var i = 0; i < this.messageStack.length; i++) {
            if(this.messageStack[i].type == this.ERROR) {
                count++;
            }
        }
        return count > 0;
    };

    this.HasWarning = function(){
        var count = 0;
        for(var i = 0; i < this.messageStack.length; i++) {
            if(this.messageStack[i].type == this.WARNING) {
                count++;
            }
        }
        return count > 0;
    };

    this.IsClear = function(){
        return this.messageStack.length == 0;
    };

    this.Display = function(bHoldAll){
        bHoldAll = bHoldAll || false;

        alertify.maxLogItems(this.messageStack.length); //.logPosition("top right")?

        for(var i = 0; i < this.messageStack.length; i++) {
            var duration = (bHoldAll) ? 0 : this.messageStack[i].duration;
            switch(this.messageStack[i].type) {
                case this.NOTICE:
                    alertify.delay(duration).closeLogOnClick(true).log(this.messageStack[i].message);
                    break;
                case this.SUCCESS:
                    alertify.delay(duration).closeLogOnClick(true).success(this.messageStack[i].message);
                    break;
                case this.WARNING:
                    alertify.delay(duration).closeLogOnClick(true).warning(this.messageStack[i].message);
                    break;
                case this.ERROR:
                    alertify.delay(duration).closeLogOnClick(true).error(this.messageStack[i].message);
                    break;
                default:
                    alertify.delay(duration).closeLogOnClick(true).log(this.messageStack[i].message);
            }
        }

        alertify.reset();

    };

    this.Clear = function(){
       this.messageStack = [];
    };
};
